import { Skeleton } from 'antd'
import type { JSX } from 'react'
import styles from './ui-skeleton.module.scss'

const UiSkeleton = Skeleton

export default UiSkeleton

/** Hình khung giả: bảng · chi tiết (lưới nhãn/giá trị) · form (nhãn + ô nhập). */
export type SkeletonKind = 'table' | 'detail' | 'form'

const TABLE_ROWS = 6
const TABLE_COLS = 6
const DETAIL_FIELDS = 8
const FORM_FIELDS = 5

const range = (n: number) => Array.from({ length: n }, (_, i) => i)

const TableShape = () => (
  <>
    <div className={styles.tableRow}>
      {range(TABLE_COLS).map((c) => (
        <div key={c} className={styles.headCell} />
      ))}
    </div>
    {range(TABLE_ROWS).map((r) => (
      <div key={r} className={styles.tableRow}>
        {range(TABLE_COLS).map((c) => (
          <div key={c} className={styles.cell} />
        ))}
      </div>
    ))}
  </>
)

const DetailShape = () => (
  <div className={styles.detailGrid}>
    {range(DETAIL_FIELDS).map((i) => (
      <div key={i} className={styles.field}>
        <div className={styles.label} />
        <div className={styles.value} />
      </div>
    ))}
  </div>
)

const FormShape = () => (
  <div className={styles.form}>
    {range(FORM_FIELDS).map((i) => (
      <div key={i} className={styles.field}>
        <div className={styles.label} />
        <div className={styles.input} />
      </div>
    ))}
  </div>
)

const SHAPES: Record<SkeletonKind, () => JSX.Element> = {
  table: TableShape,
  detail: DetailShape,
  form: FormShape,
}

/** Khung giả theo kind, chưa bọc phantom-ui. */
export const SkeletonShape = ({ kind }: { kind: SkeletonKind }) => {
  const Shape = SHAPES[kind]
  return (
    <div className={styles.shape}>
      <Shape />
    </div>
  )
}

/** Khung giả theo kind, bọc phantom-ui để phủ shimmer lên đúng từng khối. */
export const PhantomSkeleton = ({ kind }: { kind: SkeletonKind }) => (
  <phantom-ui loading animation="shimmer" reveal={0.1} class="block">
    <SkeletonShape kind={kind} />
  </phantom-ui>
)
